import { create } from 'zustand';
import EstadoGlobal from '../types/EstadoGlobal';

const globalStore = create<EstadoGlobal>((set) => ({
    seccion: 'inicio',
    setSeccion: (seccion: string) => set({ seccion }),
}));

export default globalStore;